// Crop + fit an uploaded image to the e-mail header band (600×260 → rendered at 2× for retina).
// Too wide → crop to centre. Too tall → crop to the top third (focal point usually sits high).
export const HEADER_W = 1200;
export const HEADER_H = 520;
export const HEADER_ACCEPT = ["image/jpeg", "image/png", "image/gif"];

export function cropToHeader(file) {
  return new Promise((resolve, reject) => {
    if (!HEADER_ACCEPT.includes(file.type)) return reject(new Error("Only JPG, PNG or GIF images are accepted"));
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      const target = HEADER_W / HEADER_H;
      const ratio = img.naturalWidth / img.naturalHeight;
      let sx = 0, sy = 0, sw = img.naturalWidth, sh = img.naturalHeight;
      if (ratio > target) {
        sw = Math.round(img.naturalHeight * target);
        sx = Math.round((img.naturalWidth - sw) / 2);
      } else if (ratio < target) {
        sh = Math.round(img.naturalWidth / target);
        sy = Math.round(Math.max(0, (img.naturalHeight - sh) / 3));
      }
      const canvas = document.createElement("canvas");
      canvas.width = HEADER_W; canvas.height = HEADER_H;
      const ctx = canvas.getContext("2d");
      ctx.imageSmoothingQuality = "high";
      ctx.drawImage(img, sx, sy, sw, sh, 0, 0, HEADER_W, HEADER_H);
      const outType = file.type === "image/png" ? "image/png" : "image/jpeg";
      const dataUrl = canvas.toDataURL(outType, 0.9);
      resolve({ dataUrl, contentType: outType, base64: dataUrl.split(",")[1] });
    };
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error("Could not read that image")); };
    img.src = url;
  });
}
